module.exports = __webpack_public_path__ + "media/images/redesign-images/fraternity-new/frat-partnerships-768f4ff301810052c0822fef5764fdac.png";